const de = {
  info: 'Die Wahlergebnisse wurden veröffentlicht'
};

export default de;
export type AWPMFWPMNotificationsTranslation = typeof de;
